import { createSlice } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: {
    alert: null,
  },
  reducers: {
    pushAlert: (state, action) => {
      state.alert = action.payload;
    },
  },
});

export const { pushAlert } = alertSlice.actions;

export default alertSlice.reducer;
